'use strict';

import { skipLinkFocusFix, mobileAdminBarFix } from './modules/wp';
import { initMasthead } from './modules/masthead';
import { initMDCTemporaryDrawers, initSearchDrawer } from './modules/drawer';
import { initMDCSimpleMenus } from './modules/menu';
import { initMDCTextFields } from './modules/text-field';
import { initMDCRipples } from './modules/ripple';
import { initMDCDialogs } from './modules/dialog';
import { initIsotopeGalleries, initIsotopeFooterMenus } from './modules/isotope';
import { initPhotoSwipeGalleries } from './modules/photoswipe';
import { initContactValidations } from './modules/contact';
import { initFlickityCardCarousels } from './modules/flickity';
import { initJumpLinks } from './modules/jump';
import { initImageFaders } from './modules/image-fader';
// import { initIntersectAnimations } from './modules/intersect-animation';

// Run synchronously.
skipLinkFocusFix();
mobileAdminBarFix();
initContactValidations();
initIsotopeGalleries();
initFlickityCardCarousels();
initImageFaders(5000);
// initIntersectAnimations();

// Run on document ready.
document.addEventListener('DOMContentLoaded', (e) => {
	initMasthead();
	initMDCTemporaryDrawers();
	initMDCSimpleMenus();
	initMDCTextFields();
	initJumpLinks();
	initPhotoSwipeGalleries();
	initMDCRipples();
	initMDCDialogs();
	initIsotopeFooterMenus();
	initSearchDrawer();
});
